import { useParams } from 'react-router';
import { useRouteMatch } from 'react-router-dom';
import {
    PAGE_STATE_DURING_EVENT,
    PAGE_STATE_DURING_EVENT_MULTI_SESSION,
    TYPE_VIRTUAL_EVENT_MULTISESSION,
} from 'common/constants/virtualEvent';

const PREVIEW_INTERFACES = ['virtual', 'agenda'].join('|');
const PREVIEW_ROUTE_MATCH = `/content/(${PREVIEW_INTERFACES})/preview`;

export function usePreview({ event }) {
    const { previewStateName } = useParams();
    const match = useRouteMatch(PREVIEW_ROUTE_MATCH);
    const isVirtualSessionEvent = event?.multisession === TYPE_VIRTUAL_EVENT_MULTISESSION;
    const isPreviewRootPath = match?.isExact;
    const shouldPreview = !!previewStateName || isPreviewRootPath;

    if (isVirtualSessionEvent && previewStateName === PAGE_STATE_DURING_EVENT) {
        return { shouldPreview, previewStateName: PAGE_STATE_DURING_EVENT_MULTI_SESSION };
    }

    return { shouldPreview, previewStateName, isPreviewRootPath };
}
